// removed by extract-text-webpack-plugin
module.exports = {"gray":"#EFEFEF","blue":"#00A8E8","green":"#99C24D","items":"src-components-IconList----IconList-module---items---2v5by","active":"src-components-IconList----IconList-module---active---82NYG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconList/IconList.module.css
// module id = 626
// module chunks = 267780758595360